import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { CacheService } from "obscache";
import { Observable } from "rxjs/Observable";
import { SiteUser } from "../../../../common/interfaces";

export type User = SiteUser;

@Injectable()
export class UserService {
  constructor(private cache: CacheService, private http: Http) {}

  get(): Observable<User> {
    return this.cache.get("user").miss(() => ({
      value: this.http.get("/session/user").map(res => res.json()),
      expires: "1h"
    }));
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/user/user.service.ts